import * as angular from "angular";
import {IController} from "angular";
import {TaskModel} from "../../models/task.model";

export class taskEtaTextCtrl implements IController {

  status: any;
  task: TaskModel;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('taskEtaText', {
    bindings: {
      status: '<',
      task: '<',
    },
    template: require('./task-eta-text.html').default,
    controller: taskEtaTextCtrl
  });
